<div class="modal fade" id="paymentSettingsModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="paymentSettingsTitle">Payment Profile</h5>
        <button id="closePaymentSettingsModal" type="button" class="close" (click)="closePaymentProfile()"
          data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="accountPaymentSetting && accountPaymentSetting.paymentInstruments" class="container">
          <div class="row">
            <div class="col-6">
              <div *ngFor="let setting of paymentSettings" class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="{{setting}}Radio" name="{{setting}}Radio" value="{{setting}}"
                  [(ngModel)]="accountPaymentSetting.paymentSetting" class="custom-control-input"
                  [disabled]="!(accountPaymentSetting && accountPaymentSetting.paymentInstruments && accountPaymentSetting.paymentInstruments.length && isEditPaymentSettingEnabled)">
                <label class="custom-control-label" for="{{setting}}Radio">{{setting | customText}}</label>
              </div>
            </div>
            <div class="col-6 text-right"
              *ngIf="(accountPaymentSetting && accountPaymentSetting.paymentInstruments && accountPaymentSetting.paymentInstruments.length)">
              <i *ngIf="!isEditPaymentSettingEnabled" class="fas fa-edit cursor-pointer ml-3 maroon"
                data-toggle="tooltip" data-placement="right" title="Edit Payment Instruments"
                (click)="enableEditingPaymentSetting()"></i>
              <i *ngIf="isEditPaymentSettingEnabled" class="fa fa-window-close cursor-pointer ml-3 maroon"
                data-toggle="tooltip" data-placement="right" title="Cancel" (click)="enableEditingPaymentSetting()"></i>
              <div class="mt-2" *ngIf="isEditPaymentSettingEnabled">
                <button type="button" class="btn btn-primary border btn-80" (click)="confirmUpdate()">Save</button>
              </div>
            </div>
          </div>
          <div
            *ngIf="accountPaymentSetting && accountPaymentSetting.paymentInstruments && accountPaymentSetting.paymentInstruments.length == 0">
            <label class="mt-1"><span class="text-muted font13-400">Auto payment setup requires a saved payment
                instrument.</span></label>
          </div>
        </div>

        <!--New Changes start-->

        <div *ngIf="accountPaymentSetting && accountPaymentSetting.paymentInstruments" class="container mt-4">
          <div class="row">
            <div class="col-9">
              <label for="vin" class="font14-400">Payment Instruments</label>
            </div>
            <div class="col-3 text-right"
              *ngIf="accountPaymentSetting && accountPaymentSetting.paymentInstruments && accountPaymentSetting.paymentInstruments.length > 0">
              <i *ngIf="!isEditPaymentInstrumentsEnabled" class="fas fa-edit cursor-pointer ml-3 maroon"
                data-toggle="tooltip" data-placement="right" title="Edit Payment Instruments"
                (click)="enableEditingPaymentInstruments()"></i>
              <i *ngIf="isEditPaymentInstrumentsEnabled" class="fa fa-window-close cursor-pointer ml-3 maroon"
                data-toggle="tooltip" data-placement="right" title="Cancel"
                (click)="enableEditingPaymentInstruments()"></i>
            </div>
          </div>

          <form class="mt-2" #paymentInstrumentsForm="ngForm" novalidate (ngSubmit)="paymentInstrumentsForm.form.valid">
            <div *ngFor="let instrument of accountPaymentSetting.paymentInstruments; let i = index;"
              class="row border-bottom-grey mt-4 pb-2 font13-400">
              <div class="col-8 pointer">
                <div>
                  <span *ngIf="instrument.mode == paymentTypes[1] && getPaymentIcon(instrument.summary.cardType)"><img
                      class="img-fluid payment-icon" [src]="getPaymentIcon(instrument.summary.cardType)"
                      alt="{{instrument.summary.cardType}}" />&nbsp;</span>
                  <span>{{instrument.mode}}&nbsp;&nbsp;</span>
                  <span class="text-muted">ending in <span
                      *ngIf="instrument.mode == paymentTypes[0]">{{getLastFourDigit(instrument.summary.accountNo)}}</span><span
                      *ngIf="instrument.mode == paymentTypes[1]">{{getLastFourDigit(instrument.summary.cardNo)}}</span>&nbsp;&nbsp;</span>
                </div>
                <div class="mt-2 text-muted">
                  <span
                    *ngIf="instrument.mode == paymentTypes[0]">{{instrument.summary.accountType | customText}}</span>
                  <span *ngIf="instrument.mode == paymentTypes[1]">Expiry: {{instrument.summary.expiry}}</span>
                </div>
                <div
                  *ngIf="(!isEditPaymentInstrumentsEnabled && instrument.isDefault && accountPaymentSetting.paymentInstruments.length > 1)"
                  class="mt-2 maroon"><i>(Preferred Payment Mode)</i></div>
                <div *ngIf="isEditPaymentInstrumentsEnabled && accountPaymentSetting.paymentInstruments.length > 1"
                  class="custom-control custom-checkbox mt-2">
                  <input type="checkbox" class="custom-control-input pointer" id="paymentInstrument_{{i}}"
                    name="paymentInstrument_{{i}}" [(ngModel)]="instrument.isDefault"
                    (change)="onCheckedChange(i, $event.target.checked);">
                  <label class="custom-control-label pointer" for="paymentInstrument_{{i}}"><i>Preferred Payment
                      Mode</i></label>
                </div>
              </div>
              <div class="col-4">
                <div *ngIf="isEditPaymentInstrumentsEnabled" class="text-right"><i *ngIf="isShowDelete(instrument)"
                    class="pointer fa fa-trash maroon" (click)="onDeletePaymentInstrument(instrument)"></i></div>
              </div>
            </div>
            <div class="font13-400 mt-2"
              *ngIf="accountPaymentSetting && (!accountPaymentSetting.paymentInstruments || accountPaymentSetting.paymentInstruments.length==0)">
              <span>None</span> <br>
              <label class="mt-3">
                <span class="text-muted">Payment instrument can be saved during an invoice payment.</span></label>
            </div>
          </form>

        </div>

        <!--New Changes ends-->
      </div>
      <div class="m1" *ngIf="isEditPaymentInstrumentsEnabled" class="m-2 text-right">
        <button type="submit" class="btn btn-primary border btn-80" (click)="confirmUpdate()">Save</button>
      </div>
    </div>
  </div>
</div>

<!--Delete Payment Instrument Modal-->
<div class="modal fade" id="deletePaymentInstrumentModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="apiAccessTitle">Delete Payment Instrument</h5>
        <button id="closeDeletePaymentInstrumentModal" type="button" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div class="align-self-center text-center">
          <span *ngIf="showErrorMessage">{{deleteModalBodyText}}</span>
          <span *ngIf="!showErrorMessage">{{deleteModalBodyText}}</span>
        </div>
        </div>
      <div *ngIf="!showErrorMessage" class="modal-footer">
        <button type="button" class="btn btn-light  btn-80" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary  btn-80" (click)="confirmDelete();">OK</button>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary" id="openDeletePaymentInstrumentModal" [hidden]="true" data-toggle="modal"
  data-target="#deletePaymentInstrumentModal" data-backdrop="static" data-keyboard="false">Hidden Btn</button>


<!--Update Payment Instruments Modal-->
<div class="modal fade" id="updatePaymentInstrumentModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="apiAccessTitle">Save</h5>
        <button id="closeUpdatePaymentInstrumentModal" type="button" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div class="align-self-center text-center">Do you want to save the changes?</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" (click)="cancelUpdate()" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" (click)="confirmUpdate();">SAVE</button>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary" id="openUpdatePaymentInstrumentModal" [hidden]="true" data-toggle="modal"
  data-target="#updatePaymentInstrumentModal" data-backdrop="static" data-keyboard="false">Hidden Btn</button>